<script>
// 1. Import the new helper function
import { lookupByNumber } from '@/utils/abnAcnUtils';

export default {
  name: 'AbnAcnInput',
  props: {
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isLoading: false,
      isAbnValid: false, // New state to track successful validation
      debounceTimer: null,
    };
  },
  computed: {
    numberValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        const sanitizedValue = newValue.replace(/[^\d]/g, '');
        this.isAbnValid = false; // Reset success state on new input
        this.$emit('input', sanitizedValue);
        this.debounceValidation(sanitizedValue);
      }
    }
  },
  methods: {
    debounceValidation(number) {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }

      const isValidLength = number.length === 9 || number.length === 11;
      if (!number || !isValidLength || this.disabled) {
        this.isLoading = false;
        return;
      }
      this.debounceTimer = setTimeout(() => {
        this.performLookup(number);
      }, 500);
    },

    // 2. Refactor the lookup method to be a simple async function
    async performLookup(number) {
      this.isLoading = true;
      this.isAbnValid = false;

      try {
        const data = await lookupByNumber(number);
        if (data && data.EntityName) {
          this.$emit('company-name-found', data.EntityName);
          this.isAbnValid = true;
        } else {
          // ABR returns a valid response with an error message inside
          this.$box.alert('ABN/ACN not found or invalid:',data.Message,'warning');
          console.warn('ABN/ACN not found or invalid:', data.Message);
          this.$emit('company-name-found', '');
          this.isAbnValid = false;
        }
      } catch (error) {
        // This catches network errors or other issues from the promise rejection
        this.$box.alert('ABN/ACN lookup failed:', error.message,'error');
        console.error('ABN/ACN lookup failed:', error.message);
        this.$emit('company-name-found', '');
        this.isAbnValid = false;
      } finally {
        this.isLoading = false;
      }
    },
  },
  beforeDestroy() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
  }
};
</script>

<template>
  <el-input
      v-model="numberValue"
      placeholder="ABN (11) or ACN (9) digits"
      :disabled="disabled"
      maxlength="11"
  >
    <!-- Show loading spinner while fetching -->
    <i slot="suffix" class="el-input__icon el-icon-loading" v-if="isLoading"></i>
    <!-- Show success tick when ABN/ACN is valid and not loading -->
    <i slot="suffix" class="el-input__icon el-icon-success success-tick" v-if="!isLoading && isAbnValid"></i>
    <!-- Show error cross when ABN lookup fails and not loading -->
    <i slot="suffix" class="el-input__icon el-icon-error error-cross" v-if="!isLoading && !isAbnValid"></i>
  </el-input>
</template>

<style scoped>
.success-tick {
  color: #67c23a; /* Element UI's success green color */
  font-size: 16px;
  font-weight: bold;
}

.error-cross {
  color: #f56c6c; /* Element UI's error red color */
  font-size: 16px;
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/components/common/abnAcnInput.vue